import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './core/helpers/loader.service';
import { Router, NavigationEnd } from '@angular/router';
import { GaService } from './core/helpers/ga.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LocalizationService } from './core/helpers/localization.service';
import { environment } from 'src/environments/environment';
import { CoreService } from './core/helpers/core.service';
import { DataServiceService } from './core/helpers/data-service.service';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'loyaltic-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'loyaltic';
  public loading = false;
  currentLang = 'en';
  showLocalizationPopup = false;
  showSettingIcon = false;
  isLiveUrl = false;
  cookieScriptUrl = '';
  date = new Date();
  // isComingSoon = true;
  lockview = true;
  // make isComingSoon & lockview  true while using coming-soon logic this has made false only for template
  isComingSoon = false;
  isCampaignEnded = false;
  //lockview = false;
  mySubscription:any;


  @ViewChild('localizationPopup', { static: false }) localizationPopupRef: any;
  public modalRef: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-left',
  };

  constructor(public translate: TranslateService,
    private loader: LoaderService,
    private router: Router,
    private modalService: BsModalService,
    private localizationService: LocalizationService,
    public gaService: GaService,
    private coreService: CoreService,
    private dataService: DataServiceService,
    @Inject(DOCUMENT) private doc: any
    ) {

    translate.addLangs(['en-En', 'fi-FI', 'sv-SE', 'nb-NO', 'da-DK']);

    translate.setDefaultLang('fi-FI');
    this.dataService.checkisFacebookApp();
    //if (window.location.href.toLowerCase().indexOf('swehalsko21-se.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampanj.halsanskok.se') > -1) {
    //  translate.setDefaultLang('sv-SE');
    //}
    //else if (window.location.href.toLowerCase().indexOf('swehalsko21-fi.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampanja.halsanskok.fi') > -1) {
    //  translate.setDefaultLang('fi-FI');
    //}
    //else if (window.location.href.toLowerCase().indexOf('swehalsko21-dk.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampanje.halsanskok.ne') > -1) {
    //  translate.setDefaultLang('da-DK');
    //}
    //else if (window.location.href.toLowerCase().indexOf('swehalsko21-no.azurewebsites.net') > -1 || window.location.href.toLowerCase().indexOf('kampagne.halsanskok.dk') > -1) {
    //  translate.setDefaultLang('nb-NO');
    //}

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
         // Trick the Router into believing it's last link wasn't previously loaded
         this.router.navigated = false;
      }
    });
  }

  ngOnInit(): void {
    this.checkComingSoon();
    this.addGaScript();
    this.translate.get('cookie-script').subscribe((translatedString) => {
      this.cookieScriptUrl = translatedString;
      this.loadCookieScript(this.cookieScriptUrl);
    }, error=> {
      console.log(error)
    });

    this.loader.getInputChangeLoaderEmitter().subscribe((res: any) => {
      this.loading = res;
    });

    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        // this.gaService.emitEvent('page', item.url);
      }
    });
  }

  loadCookieScript(cookieScript) {
    let dynamicScript = document.createElement("script");
    dynamicScript.type = "text/javascript";
    dynamicScript.charset = 'UTF-8'
    var doc = new DOMParser().parseFromString(cookieScript, "text/html");
    let src = doc.scripts[0].getAttribute('src');
    dynamicScript.src = src;
    document.body.appendChild(dynamicScript);
  }

  addGaScript() {
    this.translate.get('ga-script-id').subscribe((translatedString: string) => {
      let dynamicScript = document.createElement("script");
      dynamicScript.async = true;
      dynamicScript.src = 'https://www.googletagmanager.com/gtag/js?id='+translatedString;
      document.head.appendChild(dynamicScript);

      let tagScript = document.createElement("script");
      tagScript.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
  
      gtag('config', '${translatedString}');`
      document.head.appendChild(tagScript);
    }, error=> {
      console.log(error)
    });
  }

  addGTMScript() {
    this.translate.get('gtm-script-id').subscribe((translatedString) => {
      console.log("====gtm-script-id=====", translatedString);
      let dynamicScript = document.createElement("script");

      dynamicScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${translatedString}');`
      document.head.appendChild(dynamicScript);

      let tagScript = document.createElement("noscript");
      tagScript.innerHTML = `<iframe src='https://www.googletagmanager.com/ns.html?id=${translatedString}'
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`
      document.body.appendChild(tagScript);


    }, error=> {
      console.log(error)
    });
  }

  changeLanguage(key) {
    this.translate.setDefaultLang(key);
    this.translate.getTranslation(key).subscribe(translation => {
      this.translate.setTranslation(key, translation, true);
      this.translate.use(key);
    });
  }

  showLocalizations() {
    this.showLocalizationPopup = true;
    this.modalRef = this.modalService.show(this.localizationPopupRef, this.popupConfig);
  }

  async checkComingSoon() {
    const hostname = window.location.hostname;
    if (this.hasLocalComingSoonOverride(hostname)) {
      this.lockview = false;
      this.isComingSoon = environment.comingSoonRedirectOverride;
      this.isCampaignEnded = false;
      return;
    }

    // Api call for golive
    // let response = await this.liveconfig();
    await this.coreService.getLiveConfig().then((response: any) => {
      console.log("response",response)
      const goLiveDateString = response.result.liveDate;
      const goLiveDate = new Date(goLiveDateString)
      console.log("goLiveDate",goLiveDate)

      const campaignEndDateString = response.result.campaignEndDate;
      const campaignLiveDate = new Date(campaignEndDateString);
      console.log("goLiveDate",goLiveDate)
      response.result.liveUrls.forEach(element => {
        if (hostname.toLowerCase().indexOf(element) != -1){
          this.isLiveUrl = true;
        }

      });
      if (goLiveDate > this.date && this.isLiveUrl) {
        console.log("show comin soon page")
        this.lockview = false
        this.isComingSoon = true;
        this.isCampaignEnded = false;
        // this.router.navigate(['coming-soon'])
      } else if (campaignLiveDate < this.date && this.isLiveUrl) {
        console.log("campaign ended")
        this.isComingSoon = false;
        this.lockview = false
        this.isCampaignEnded = true;
        // this.router.navigate(['coming-soon'])
      } else {
        this.lockview = false
        this.isComingSoon = false;
        this.isCampaignEnded = false;
      }

    });
  }

  hasLocalComingSoonOverride(hostname: string) {
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
    return isLocalhost && environment.comingSoonRedirectOverride !== null;
  }

  appendOGMetaTags(propertyName, content) {
    var js = document.createElement("script");
    document.querySelector('meta[property=' + '"' + propertyName + '"' + ']').setAttribute("content", content);
    //  document.head.appendChild(scriptElemen);
    document.head.appendChild(js);
  }

  appendMetaTags(propertyName, content) {
    var js = document.createElement("script");
    document.querySelector('meta[name=' + propertyName + ']').setAttribute("content", content);
    //  document.head.appendChild(scriptElemen);
    document.head.appendChild(js);
  }

  appendElements(script) {
    let wrapperDi = document.createElement("div");
    let scriptElemen = document.createElement("script");
    wrapperDi.innerHTML = script
    scriptElemen.innerHTML = wrapperDi.firstElementChild.innerHTML;

    for (let i = 0; i < wrapperDi.firstElementChild.attributes.length; i++) {
      const attr = wrapperDi.firstElementChild.attributes[i];
      scriptElemen.setAttribute(attr.name, attr.value);
      console.log("scriptElemen in for-->", scriptElemen)
    }
    document.head.appendChild(scriptElemen);
  }

  appendNoScriptElements(script) {
    let wrapperDi = document.createElement("div");
    let scriptElemen = document.createElement("noscript");
    wrapperDi.innerHTML = script
    scriptElemen.innerHTML = wrapperDi.firstElementChild.innerHTML;

    // for (let i = 0; i < wrapperDi.firstElementChild.attributes.length; i++) {
    //   const attr = wrapperDi.firstElementChild.attributes[i];
    //   scriptElemen.setAttribute(attr.name, attr.value);
    //   console.log("NoscriptElement in for-->",scriptElemen)
    // }
    // document.head.appendChild(scriptElemen);
    document.body.appendChild(scriptElemen);
  }
}
